export function Fuel() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5185_4659)">
        <path
          d="M7.89844 14.3743H0.898438V3.29102C0.898438 2.29935 1.65677 1.54102 2.64844 1.54102H6.14844C7.1401 1.54102 7.89844 2.29935 7.89844 3.29102V14.3743Z"
          stroke="currentColor"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M7.89844 11.4577H9.64844C10.6401 11.4577 11.3984 10.6993 11.3984 9.70768V3.87435L13.7318 1.54102"
          stroke="currentColor"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M13.1484 2.12305V5.62305C13.1484 5.97305 12.9151 6.20638 12.5651 6.20638H11.3984"
          stroke="currentColor"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M0.898438 6.79102H7.89844"
          stroke="currentColor"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_5185_4659">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="translate(0.316406 0.957031)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
